import { render, staticRenderFns } from "./navigation-filters.vue?vue&type=template&id=bc6edb48&"
import script from "./navigation-filters.vue?vue&type=script&lang=ts&"
export * from "./navigation-filters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports